<template lang="pug">
  .camp-page
    .camp-page__body
      section.camp-page__section
        .camp-page__mobile-gallery(
          v-if="windowWidth < 1201"
        )
          .mobile-gallery
            image-slider(
              :data-images="images"
            )
        .container
          .shift
            .shift__header.shift-header
              .shift-header__main
                camp-header(
                  :camp-name="shiftData.camp_name"
                  :title="shiftData.name"
                  :tags="shiftData.tags"
                  :rating="shiftData.rating"
                )
              .shift-header__side(
                v-if="windowWidth > 1200"
              )
                .gallery
                  .photo(
                    v-for="image in shiftData.gallery"
                    @click="onClickPhoto()"
                  )
                    img(:src="image.file")
                    .img-background
            .shift__body
              .shift__main
                .shift__content.shift-content
                  .shift-content__header
                    .camp-tabs
                      .camp-tabs__container
                        .camp-tabs__item(
                          v-for="(tab, tabKey) in tabs"
                        )
                          .camp-tab-button(
                            v-bind:class="[{ 'camp-tab-button_active': currentTab === tabKey }]"
                            v-on:click="switchTab(tabKey)"
                          ) {{ tab }}
                  .shift-content__body
                    shift-program(
                    v-if="currentTab === 'program'"
                    :program="shiftData.program"
                    )
                    shift-schedule(
                    v-if="currentTab === 'schedule'"
                    :schedule="shiftData.schedule"
                    )
                    shift-teachers(
                    v-if="currentTab === 'teachers'"
                    :teachers="shiftData.teachers"
                    )
                    shift-contacts(
                    v-if="currentTab === 'contacts'"
                    :contacts="shiftData.contacts"
                    )
                    <!--.content-->
                      <!--.content__block(-->
                        <!--v-if="shiftData[currentTab]"-->
                        <!--v-html="shiftData[currentTab]"-->
                      <!--)-->
                      <!--.content__block(-->
                        <!--v-else-->
                      <!--)-->
                        <!--p Нет информации-->
              .shift__side
                .control
                  .control__info
                    ul.control-info
                      li.control-info__item(
                        v-for="item in info"
                        v-bind:key="item.name"
                      )
                        .control-info-item
                          .control-info-item__title {{ item.name }}
                          .control-info-item__text {{ shiftData[item.text] }}
                  .control__actions
                    .control-actions
                      .control-actions__item
                        .button.button_full.button_paint-main(
                          v-if="showSendRequestButton"
                          @click="onCheckUser()"
                        )
                          .button__text Отправить заявку
                      .control-actions__item
                        router-link.button.button_full(
                          :to="`/pages/camps/${shiftData.camp.id}/`"
                        )
                          .button__text Подробнее о лагере

      section.camp-page__section.section
        .container
          .section__title
            h2.section-title Все смены лагеря
          .section__body
            shifts-slider(
            :slider-data="shifts"
            :slides-count="campsSliderCount"
            )
      section.camp-page__section.section(
        v-if="windowWidth > 720"
      )
        .camp-map
          .camp-map(
            v-if="shiftData.camp.geo_lat && shiftData.camp.geo_lon"
          )
            l-map(
              ref='mainMap'
              id='mainMap'
              :zoom='zoom'
              :center='[shiftData.camp.geo_lat, shiftData.camp.geo_lon]'
              :options='mapOptions'
            )
              l-tile-layer(
                :url='url'
              )
              l-marker(
                :lat-lng='[shiftData.camp.geo_lat, shiftData.camp.geo_lon]'
                :icon="generateIcon()"
              )
      section.camp-page__section.section(
        v-if="windowWidth > 720"
      )
        .container
          .section__title
            h2.section-title Другие смены
          .section__body
            shifts-slider(
            :slider-data="otherShifts"
            :slides-count="campsSliderCount"
            )
      .camp-page__footer
        main-footer

    photo-gallery(
      :photos="shiftData.photos"
      v-show="showPhotoGallery"
      @onHidePhotoGallery="onHidePhotoGallery"
    )
    confirm-modal(
      v-if="isShowConfirmModal"
      @close="isShowConfirmModal = false"
      :text="confirmModalData.text"
      :title="confirmModalData.title"
      :button-confirm-text="confirmModalData.buttonConfirmText"
      :button-cancel-text="confirmModalData.buttonCancelText"
      :button-confirm-func="confirmModalData.buttonConfirmFunc"
    )
</template>

<script>
import {mapActions, mapState} from "vuex";
import L from "leaflet";
import {LMap, LTileLayer, LMarker} from "vue2-leaflet";

import CampHeader from "@/views/pages/campsPage/currentCamp/components/CampHeader.vue";
import OtherCamps from "@/views/pages/campsPage/currentCamp/components/OtherCamps.vue";
import MainFooter from "@/components/footer/Footer.vue";

import PhotoGallery from "@/components/photoGallery/PhotoGallery.vue";

import ConfirmModal from "@/components/modals/ConfirmModal.vue";
import ImageSlider from "../../../../components/imageSlider/ImageSlider";
import ShiftProgram from "./components/ShiftProgram";
import ShiftSchedule from "./components/ShiftSchedule";
import ShiftTeachers from "./components/ShiftTeachers";
import ShiftContacts from "./components/ShiftContacts";
//import router from "../../../../router";
import {RoleEnums} from "../../../../const/index.js";
import ShiftsSlider from "../../../../components/shifts-slider/ShiftsSlider";

export default {
  name: "CurrentShift",
  components: {
    ShiftsSlider,
    ShiftContacts,
    ShiftTeachers,
    ShiftSchedule,
    ShiftProgram,
    ImageSlider,
    CampHeader,
    OtherCamps,
    MainFooter,
    LMap,
    LTileLayer,
    LMarker,
    PhotoGallery,
    ConfirmModal
  },
  data() {
    return {
      isShowConfirmModal: false,
      zoom: 11,
      center: L.latLng(55.315919, 50.985943),
      url: "https://a.tile.openstreetmap.de/{z}/{x}/{y}.png",
      // url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
      mapOptions: {
        attributionControl: false,
        scrollWheelZoom: false
      },
      shiftData: {
        camp: {
          address: {},
          photos: []
        }
      },
      currentTab: "program",
      tabs: {
        program: "Программа",
        schedule: "Распорядок дня",
        teachers: "Педагоги",
        contacts: "Контакты"
      },
      info: [
        {
          name: "Место:",
          text: "camp_name"
        },
        {
          name: "Дата:",
          text: "camp_date"
        },
        {
          name: "Возраст:",
          text: "camp_ages"
        },
        {
          name: "Стоимость:",
          text: "full_price"
        },
        {
          name: "Всего мест:",
          text: "capacity"
        },
        {
          name: "Осталось:",
          text: "free_places"
        }
      ],
      showPhotoGallery: false,
      confirmModalData: {
        text: "Заполните анкету родителя и ребенка чтобы подать заявку",
        title: "Анкета не заполнена",
        buttonConfirmText: "Перейти в анкету ",
        buttonCancelText: "Отмена",
        buttonConfirmFunc: {
          func: this.goToProfile
        }
      },
      images: [],
      windowWidth: window.innerWidth,
      campsSliderCount: 4,
      shifts: [],
      otherShifts: []
    };
  },
  computed: {
    ...mapState(["userData", "catalogue"]),
    shiftId() {
      return this.$route.params.shiftId;
    },
    showSendRequestButton() {
      if (!this.userData || (this.userData && this.userData.role === RoleEnums.PARENT)) {
        return true;
      }
      return false;
    }
  },
  methods: {
    ...mapActions(["getShift", "getShifts"]),
    generateIcon() {
      return L.icon({
        iconUrl: require("../../../../assets/images/map/marker.svg"),
        iconSize: [40, 40],
        iconAnchor: [20, 20]
      });
    },
    switchTab(tab) {
      this.currentTab = tab;
    },
    getShiftDates(shiftRes) {
      if (shiftRes.date_started && shiftRes.date_finished) {
        const start_date = new Date(shiftRes.date_started);
        const end_date = new Date(shiftRes.date_finished);
        const months = [
          "января",
          "февраля",
          "марта",
          "апреля",
          "мая",
          "июня",
          "июля",
          "августа",
          "сентября",
          "октября",
          "ноября",
          "декабря"
        ];
        const days =
          (new Date(end_date).valueOf() - new Date(start_date).valueOf()) /
          (60 * 60 * 24 * 1000);
        return `С ${start_date.getDate()} ${
          months[start_date.getMonth()]
        }  по ${end_date.getDate()} ${months[end_date.getMonth()]}, ${
          shiftRes.duration ? shiftRes.duration : Math.round(days)
        } дней`;
      }
      return "Не известно";
    },
    getShiftAges(shiftRes) {
      if (shiftRes.age_from !== null && shiftRes.age_to !== null) {
        return `С ${shiftRes.age_from === 0 ? 6 : shiftRes.age_from} по ${
          shiftRes.age_to
        } лет`;
      }
      return "Не известно";
    },
    getShiftType(shiftRes) {
      for (var i = 0; i < this.catalogue.shiftCampTypes.length; i++) {
        if (this.catalogue.shiftCampTypes[i].value === shiftRes.type) {
          return this.catalogue.shiftCampTypes[i].text;
        }
      }
    },
    onClickPhoto() {
      this.showPhotoGallery = true;
      document.body.style.overflow = "hidden";
    },
    onHidePhotoGallery() {
      this.showPhotoGallery = false;
      document.body.style.overflow = "inherit";
    },
    onCheckUser() {
      if (!this.userData) {
        const query = Object.assign({}, this.$route.query);
        query.open_modal = "sign_in";
        this.$router.replace({query});
        return;
      }
      if (this.shiftData.free_places === 0) {
        this.$root.$emit("onShowErrorModal", {
          text: "К сожалению, свободные места на данную смену закончились."
        });
        return;
      }
      if (this.userData.first_name.length === 0) {
        this.isShowConfirmModal = true;
      } else {
        this.$router.push({
          name: "ShiftRequest",
          params: {shiftId: this.shiftId}
        });
      }
    },
    getShiftPrice(price_from, price_to) {
      if (Number(price_from) === 0 || Number(price_to) === 0) {
        return "Неизвестно";
      }
      const _price_from = (price_from / 1000).toFixed(3).replace(".", " ");
      const _price_to = (price_to / 1000).toFixed(3).replace(".", " ");
      return `${_price_from} Р - ${_price_to} Р`;
    },
    buildCurrentShift() {
      this.$root.$emit("on-show-preloader");
      this.getShift(this.shiftId).then(shiftRes => {
        this.shiftData = shiftRes;
        this.shiftData.gallery = shiftRes.photos.slice(0, 6);
        this.shiftData.camp_name = shiftRes.camp.name;
        this.shiftData.camp_date = this.getShiftDates(shiftRes);
        this.shiftData.camp_ages = this.getShiftAges(shiftRes);
        this.shiftData.camp_type = this.getShiftType(shiftRes);
        this.shiftData.full_price = this.getShiftPrice(shiftRes.price_from, shiftRes.price_to);

        this.getShifts({
          params: {
            camp: shiftRes.camp.id
          }
        }).then(res => {
          this.shifts = res.results;
        });

        this.$root.$emit("on-hide-preloader");
      });
    },
    goToProfile() {
      this.$router.push("/pages/profile/");
    },
    calcSlidesCount() {
      this.windowWidth = window.innerWidth;
      if (this.windowWidth > 1340) {
        this.campsSliderCount = 4;
      } else if (this.windowWidth < 1341 && this.windowWidth > 720) {
        this.campsSliderCount = 3;
      } else {
        this.campsSliderCount = 1;
      }
    }
  },
  mounted() {
    this.buildCurrentShift();
    this.$root.$on("onSubmitAuthModal", () => {
      this.onCheckUser();
    });
    this.calcSlidesCount();
    this.getShifts({
      params: {
        limit: 8
      }
    }).then(res => {
      this.otherShifts = res.results;
    });

    window.onresize = () => {
      this.calcSlidesCount();
    };
  },
  beforeDestroy() {
    this.$root.$off("onSubmitAuthModal");
  },
  watch: {
    "$route.params.shiftId"() {
      this.buildCurrentShift();
    },
    shiftData(val) {
      for (var i = 0; i < this.shiftData.gallery.length; i++) {
        this.images.push(this.shiftData.gallery[i].file);
      }
    }
  }
};
</script>
